export default __webpack_public_path__ + "files/bcfa0e5662ad3a5c69507c2a8845d7bb.mp3";